import {
    SETTINGS_AI_COLLECTION_AUTO_PUBLISHING_ENABLED_SLUG,
    SETTINGS_AI_COLLECTION_AUTO_QUICK_FILTERS_ENABLED_SLUG,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsCollectionPublication = () =>
    useSettingsFactory({
        autoPublishing: { path: SETTINGS_AI_COLLECTION_AUTO_PUBLISHING_ENABLED_SLUG },
        autoQuickFilters: { path: SETTINGS_AI_COLLECTION_AUTO_QUICK_FILTERS_ENABLED_SLUG },
    });
